// query-string requires this package as a function. decode-uri-component 0.5
// is ESM-only, and Vite's dev prebundle turns that default export into an
// object, so search URLs throw "decodeComponent is not a function".
function decodeComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError(`Expected \`encodedURI\` to be of type \`string\`, got \`${typeof encodedURI}\``);
  }
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return encodedURI;
  }
}

module.exports = decodeComponent;
